import axios from 'axios'

const serverKeyMap = {
    'replyTo': 'parent_id'
};


export default {

    /**
     * Get paginated comments for material.
     *
     * @param materialId
     * @param params
     * @returns {AxiosPromise<any>}
     */
    get: function (materialId, params) {
        return axios.get('/api/materials/' + materialId + '/comments', { params });
    },

    /**
     * Create a comment. Provide reply-to comment id to create a reply.
     *
     * @param materialId
     * @param data
     * @returns {AxiosPromise<any>}
     */
    create: function (materialId, data) {

        data = _.mapKeys(data, function (value, key) {
            return serverKeyMap.hasOwnProperty(key) ? serverKeyMap[key] : key;
        });

        return axios.post('/api/materials/' + materialId + '/comments', data);
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/api/comments.js